import React from 'react';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import {MailThread, ManualMailMailThread} from 'api';
import Messages from './Messages';

interface ManualMail extends MailThread {
  threadable: ManualMailMailThread;
}

interface Props {
  mailThread: ManualMail;
}

export default ({mailThread}: Props) => {
  const history = useHistory();
  const {
    threadable: {manualMail},
    mailMessages,
  } = mailThread;

  return (
    <Container>
      <a onClick={history.goBack}>&lt; 戻る</a>
      <h2>{manualMail.subject}</h2>
      <Messages mailMessages={mailMessages} />
    </Container>
  );
};

const Container = styled.div`
  h2 {
    font-weight: 500;
    font-size: 16px;
    margin-top: 1rem;
  }
`;
